export default function handleResizePositionFixedComponentUtil (props) {
  logUtil('handleResizePositionFixedComponentUtil').debug('[start] props=', props)
  const { ref, isInsideParent, parentRef } = props

  if (isInsideParent && ref.current?.parentNode === parentRef?.current) {
    logUtil('handleResizePositionFixedComponentUtil').debug('[noop] parentRef is already the parent')
    return
  }

  if (isInsideParent) {
    parentRef?.current?.appendChild?.(ref.current)
    logUtil('handleResizePositionFixedComponentUtil').debug('append to parentRef')
    return
  }

  const body = document.querySelector('body')
  if (!isInsideParent && ref.current?.parentNode === body) {
    logUtil('handleResizePositionFixedComponentUtil').debug('[noop] body is already the parent')
    return
  }

  body.appendChild(ref.current)
  logUtil('handleResizePositionFixedComponentUtil').debug('append to body')
}
